<template>
  <div class="nav is-fixed">
    <scrollactive
      ref="scrollactive"
      :offset="offset"
      :always-track="alwaysTrack"
      :duration="duration"
      :click-to-scroll="clickToScroll"
      :bezier-easing-value="easing"
    >
      <b-nav vertical>
        <b-nav-item>
          <h1 id="logo" href="#">
            <a href="#about" style="color: #f05e25 !important;" class="scrollactive-item nav-item logolink">dian</a>
            <span class="disableLink"> ></span>
            <span class="blinking">_</span>
          </h1>
        </b-nav-item>
        <b-nav-item href="#about" style="text-align: right">
          <a href="#about" class="scrollactive-item nav-item sectionlink">About Me</a>
        </b-nav-item>
        <b-nav-item href="#work" style="text-align: right">
          <a href="#work" class="scrollactive-item nav-item sectionlink">Work Experience</a>
        </b-nav-item>
        <b-nav-item href="#projects" style="text-align: right">
          <a href="#projects" class="scrollactive-item nav-item sectionlink">Projects</a>
        </b-nav-item>
      </b-nav>
    </scrollactive>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      alwaysTrack: false,
      duration: 600,
      clickToScroll: true,
      offset: 0,
      easing: ".5,0,.35,1"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "src/sass/app";
@import url('https://fonts.googleapis.com/css?family=ZCOOL+KuaiLe');
.nav.is-fixed {
  position: fixed;
  .is-active {
    color: $section_highlight;
    font-weight: 700;
  }
}

#logo {
  font-size: 2.5em;
  display: inline-block;
  background-color: #1a252c;
  padding: 0px 10px 10px 5px;
  font-family: 'ZCOOL KuaiLe', cursive;
  text-align: right;
  border: 2px solid rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  cursor: default;
}

.disableLink {
  pointer-events: none;
  text-decoration: none;
  color: white;
  cursor: default;
  font-size: 50px !important;
}
.sectionlink{
  color: #bbb;
  display: block;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1)
}

.blinking {
  color: white;
  text-shadow: 1px 1px 0px rgba(0, 0, 0, 0.5);
  animation: blink 1s linear infinite alternate;
}

.logolink {
  color: #f05e25 !important;
  text-decoration: none;
  padding: 0px 10px 0px 15px;
  font-weight: 700;
}

.logolink:hover {
  color: #c04729 !important;
  text-decoration: none;
}

.logolink:visited {
  text-decoration: none;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
